import React from 'react';
import './SetupOther.css'

function SetupOther () {
   
        return (
            <div>
                 <div className="page-wrapper">

      <div className="top-header">

        <div className="header-left-other">
          <div className="page-title">Thiết lập khác</div>

          <div className="breadcrumb">
            Trang chủ / Cấu hình hệ thống / Thiết lập khác
          </div>
        </div>

        <button className="save-button">
            <i className="fa-solid fa-lock btn-lock"></i>
           Lưu cấu hình
        </button>

      </div>

      <div className="content-grid">

        {/* <!-- Cấu hình đăng xuất --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình đăng xuất</div>

          <div className="setting-row">
            <div className="setting-label">
              Tự động đăng xuất khi không hoạt động
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="logout1" checked />
                <label className="toggle-label" for="logout1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Thời gian không hoạt động (phút)
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="30" />
              <span className="unit-text">phút</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hiển thị cảnh báo trước khi đăng xuất
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="logout2" checked />
                <label className="toggle-label" for="logout2"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Thời gian cảnh báo (giây)
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="60" />
              <span className="unit-text">giây</span>
            </div>
          </div>

        </div>

        {/* <!-- Cấu hình phiên làm việc --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình phiên làm việc</div>

          <div className="setting-row">
            <div className="setting-label">
              Giới hạn số đa phiên đăng nhập đồng thời
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="5" />
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hành động khi vượt quá giới hạn
            </div>

            <div className="setting-control">
              <select className="select-field">
                <option>Đăng xuất phiên cũ nhất</option>
              </select>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Gia hạn phiên khi hoạt động
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="session1" checked />
                <label className="toggle-label" for="session1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Thời gian gia hạn (phút)
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="15" />
              <span className="unit-text">phút</span>
            </div>
          </div>

        </div>

        {/* <!-- Cấu hình tải lên --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình tải lên</div>

          <div className="setting-row">
            <div className="setting-label">
              Dung lượng file tối đa cho phép
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="50" />
              <span className="unit-text">MB</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Định dạng file cho phép
            </div>

            <div className="setting-control file-types">
              <div className="file-badge">.pdf</div>
              <div className="file-badge">.doc</div>
              <div className="file-badge">.docx</div>
              <div className="file-badge">.xls</div>
              <div className="file-badge">.xlsx</div>
              <div className="file-badge">jpg</div>
              <div className="file-badge">png</div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Quét virus cho file tải lên
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="upload1" checked />
                <label className="toggle-label" for="upload1"></label>
              </div>
            </div>
          </div>

        </div>

        {/* <!-- Cấu hình hệ thống --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình hệ thống</div>

          <div className="setting-row">
            <div className="setting-label">
              Chế độ bảo trì hệ thống
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="system1" />
                <label className="toggle-label" for="system1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Thông báo bảo trì
            </div>

            <div className="setting-control full-width-control">
              <div >
                <textarea className="textarea-field-system" placeholder="Nhập thông báo bảo trì hệ thống..."></textarea>
                <div className="counter-text">0/255</div>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Email nhận thông báo lỗi hệ thống
            </div>

            <div className="setting-control full-width-control">
              <div >
                <input className="input-field"  type="text" value="admin@angiang.gov.vn" />
                <div className="email-note">
                  Nhiều email cách nhau bởi dấu phẩy (,)
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* <!-- Cấu hình in ấn --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình in ấn</div>

          <div className="setting-row">
            <div className="setting-label">
              Khổ giấy mặc định
            </div>

            <div className="setting-control">
              <select className="select-field">
                <option>A4</option>
              </select>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hướng giấy mặc định
            </div>

            <div className="setting-control">
              <select className="select-field">
                <option>Ngang</option>
              </select>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hiển thị logo trên báo cáo
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="print1" checked />
                <label className="toggle-label" for="print1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hiển thị chữ ký trên báo cáo
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="print2" checked />
                <label className="toggle-label" for="print2"></label>
              </div>
            </div>
          </div>

        </div>

        {/* <!-- Cấu hình thông báo --> */}
        <div className="setting-card">

          <div className="card-title">Cấu hình thông báo trong hệ thống</div>

          <div className="setting-row">
            <div className="setting-label">
              Hiển thị thông báo toast
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="notify1" checked />
                <label className="toggle-label" for="notify1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Thời gian hiển thị toast (giây)
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="5" />
              <span className="unit-text">giây</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Âm thanh thông báo
            </div>

            <div className="setting-control">
              <select className="select-field">
                <option>Chuông mặc định</option>
              </select>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Hiển thị số lượng thông báo chưa đọc
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="notify2" checked />
                <label className="toggle-label" for="notify2"></label>
              </div>
            </div>
          </div>

        </div>


      </div>
        {/* <!-- Cấu hình API --> */}
        <div className="setting-card-internal">
            <div className="card-title">
                <h5>Cấu hình API nội bộ</h5>
            </div>
            
           <div className='setup-internal'>

            <div className='content-share-left'>

          <div className="setting-row">
             
            <div className="setting-label">
              Cho phép truy cập API nội bộ
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="api1" checked />
                <label className="toggle-label" for="api1"></label>
              </div>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Token hết hạn sau (phút)
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="60" />
              <span className="unit-text">phút</span>
            </div>
          </div>
            </div>

            <div  className='content-share-right'>
                 <div className="setting-row">
            <div className="setting-label">
              Giới hạn số lượng request
            </div>

            <div className="setting-control">
              <input className="input-field" type="text" value="1000" />
              <span className="unit-text">request/phút</span>
            </div>
          </div>

          <div className="setting-row">
            <div className="setting-label">
              Ghi log API nội bộ
            </div>

            <div className="setting-control">
              <div className="toggle-wrapper">
                <input className="toggle-input" type="checkbox" id="api2" checked />
                <label className="toggle-label" for="api2"></label>
              </div>
            </div>
          </div>

            </div>
           </div>

           

         
        </div>

    </div>
            </div>
        );
    
}



export default SetupOther;